import { createGlobalStyle } from 'theme';

export const Anchor = createGlobalStyle`
  a {
    color: ${(p) => p.theme.colors.gray900};
    text-decoration: none;
    transition: color ${(p) => p.theme.transitions.default};
  }
`;
